function getExportOptions() {
  return [require("./html5.js"), require("./placeholder.js")];
}

module.exports = { getExportOptions };
